/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./digitalTwinDetails.vue?vue&type=template&id=a3b91952&scoped=true"
import script from "./digitalTwinDetails.vue?vue&type=script&lang=js"
export * from "./digitalTwinDetails.vue?vue&type=script&lang=js"
import style0 from "./digitalTwinDetails.vue?vue&type=style&index=0&id=a3b91952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b91952",
  null
  
)

export default component.exports